import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../Tooltip/Tooltip'
import styles from './notificationCard.scss'

export const TOOLTIPS_TEXTS = {
  notRead: 'Não lida',
  notInterected: 'Não interagida'
}

const NotificationCardFeedbackHeader = (props = {}) => {
  const { isRead, isInterected } = props

  // Priorize rendering the "notRead" tooltip
  const renderNotRead = !isRead
  // Only display "notInteracted" Tooltip if the message is read and not interected
  const renderNotInterected = !renderNotRead && !isInterected

  return (
    <>
      {renderNotRead && (
        <Tooltip legend={TOOLTIPS_TEXTS.notRead} size="small" type="notRead">
          <span className={styles.mark} />
        </Tooltip>
      )}

      {renderNotInterected && (
        <Tooltip
          legend={TOOLTIPS_TEXTS.notInterected}
          size="medium"
          type="notInterected"
        >
          <span className={styles.mark} />
        </Tooltip>
      )}
    </>
  )
}

NotificationCardFeedbackHeader.defaultProps = {
  isRead: null,
  isInterected: null
}

NotificationCardFeedbackHeader.propTypes = {
  isRead: PropTypes.bool,
  isInterected: PropTypes.bool
}

export default NotificationCardFeedbackHeader
